import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeadlessInput from '../../shared/component/headless/input/HeadlessInput';
import { MemberInfoValue } from '../../shared/component/headless/input/InputBody';
import HeadlessBtn from '../../shared/component/headless/button/HeadlessBtn';
import { BlackFitBtn } from '../../shared/component/headless/button/BtnBody';
import { useModalStore } from '../../shared/store/portal/modalStore';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import deleteIcon from '../../asset/icon/delete.png';
import { ChangeModalFrame } from '../../shared/component/modal/ChangeModalFrame';
import { getModalMessage } from '../../shared/constants/modalMessages';
import { getBtnName } from '../../shared/constants/btnNames';

interface ModalProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

const ChangeUsernameModal: React.FC<ModalProps> = ({ setIsUserInput }) => {
  const { standardModal, isClosing, clearModal } = useModalStore();
  const [username, setUsername] = useState(standardModal?.value || "");

  useEffect(() => {
    if (username.trim().length > 0) {
      setIsUserInput(true);
    } else {
      setIsUserInput(false);
    }
  }, [username, setIsUserInput]);

  if (standardModal == null) return null;

  const handleChangeUsername = () => {
    const normalizedUsername = username.trim();
    if (!normalizedUsername) return;
    if (standardModal.handleChange) {
      standardModal.handleChange(normalizedUsername);
    }
    clearModal();
  };

  return (
    <ChangeModalFrame
      onClick={(e) => e.stopPropagation()}
      $isClosing={isClosing}
    >
      <ChangeUsernameModalComp>
        <HeaderRow>
          <Title>{getModalMessage('CHANGE_USERNAME_TITLE')}</Title>
          <UniversalIconBtn
            size="small"
            border={false}
            isTransparent
            hoverOpacity
            backgroundImg={deleteIcon}
            onClick={() => clearModal()}
          />
        </HeaderRow>
        <HeadlessInput
          type={'text'}
          value={username}
          handleChange={(e) => setUsername(e.target.value.slice(0, 30))}
          placeholder={getModalMessage('ENTER_FIELD', { field: standardModal?.title ?? '' })}
          StyledInput={MemberInfoValue}
        />
        <BtnContainer>
          <HeadlessBtn
            value={getBtnName('CHANGE')}
            handleClick={handleChangeUsername}
            StyledBtn={BlackFitBtn}
          />
        </BtnContainer>
      </ChangeUsernameModalComp>
    </ChangeModalFrame>
  );
};

const ChangeUsernameModalComp = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0.5vw;
`

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 3vh;
`;

const Title = styled.h2`
  min-width: 0;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_02_1};
`;

const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 1vh;

  margin-top: 2.5vh;
`

export default ChangeUsernameModal;
